import { Outlet, Route, Routes } from 'react-router-dom'
import Demo from '@/pages/Demo'
// import Login from '@/pages/Login'
import Home from '../pages/Home'
import NotFound from '../pages/NotFound'
// player
import PlayerList from '@/pages/player/list'
import PlayerDetail from '@/pages/player/detail'
import PlayerFace from '@/pages/player/face'
import PlayerName from '@/pages/player/name'
import PlayerAgreement from '@/pages/player/agreement'
// chess
import PlayerSwitch from '@/pages/player/switch'
import ChessIndex from '@/pages/chess/index'
import ChessHistory from '@/pages/chess/history'
import ChessList from '@/pages/chess/list'
// registration
import RegistrationIndex from '@/pages/registration/index'
import RegistrationGrade from '@/pages/registration/grade'
import RegistrationNotice from '@/pages/registration/notice'
import RegistrationStep1 from '@/pages/registration/step1'
import RegistrationStep2 from '@/pages/registration/step2'
import RegistrationResult from '@/pages/registration/result'
import RegistrationList from '@/pages/registration/list'
import RegistrationCertificates from '@/pages/registration/certificates'
import RegistrationOrder from '@/pages/registration/order'
// course
import CourseIndex from '@/pages/course/index'
import CourseDetail from '@/pages/course/detail'
import CourseOrder from '@/pages/course/order'
// coupon
import CouponList from '@/pages/coupon/list'
// order
import OrderList from '@/pages/order/list'
import OrderDetail from '@/pages/order/detail'
import OrderBack from '@/pages/order/back'
// agreement
import AgreementDelete from '@/pages/agreement/pages/delete'
import AgreementFace from '@/pages/agreement/pages/face/index'
import AgreementFace2 from '@/pages/agreement/pages/face/index2'
import AgreementPrivacy from '@/pages/agreement/pages/privacy'
import AgreementRegister from '@/pages/agreement/pages/register'
import AgreementUserinfo from '@/pages/agreement/pages/userinfo'
import AgreementUserExperience from '@/pages/agreement/pages/userExperience'
// settings
import Settings from '@/pages/settings'
import Help from '@/pages/help'
import Question from '@/pages/question'
import Feedback from '@/pages/feedback'

import user from '@/stores/user'
import useDialogClear from '@/hooks/useDialogClear'
import Download from '@/pages/download'

const AppRoutes = () => {
  useDialogClear()
  return (
    <Routes>
      <Route path="" element={<Home />}></Route>
      {/* <Route path="login" element={<Login />} /> */}
      <Route path="demo" element={<Demo />} />
      <Route path="player" element={<Outlet />}>
        <Route index element={<PlayerList />} />
        <Route path="detail" element={<PlayerDetail />} />
        <Route path="name" element={<PlayerName />} />
        <Route path="face" element={<PlayerFace />} />
        <Route path="switch" element={<PlayerSwitch />} />
        <Route path="agreement" element={<PlayerAgreement />} />
      </Route>
      <Route path="chess" element={<Outlet />}>
        <Route index element={<ChessIndex />} />
        <Route path="history" element={<ChessHistory />} />
        <Route path="list" element={<ChessList />} />
      </Route>
      <Route path="registration" element={<Outlet />}>
        <Route index element={<RegistrationIndex />} />
        <Route path="grade" element={<RegistrationGrade />} />
        <Route path="notice" element={<RegistrationNotice />} />
        <Route path="step1" element={<RegistrationStep1 />} />
        <Route path="step2" element={<RegistrationStep2 />} />
        <Route path="result" element={<RegistrationResult />} />
        <Route path="list" element={<RegistrationList />} />
        <Route path="certificates" element={<RegistrationCertificates />} />
        <Route path="order" element={<RegistrationOrder />} />
      </Route>
      <Route path="course" element={<Outlet />}>
        <Route index element={<CourseIndex />} />
        <Route path="detail" element={<CourseDetail />} />
        <Route path="order" element={<CourseOrder />} />
      </Route>
      <Route path="coupon" element={<Outlet />}>
        <Route index element={<CouponList />} />
      </Route>
      <Route path="order" element={<Outlet />}>
        <Route index element={<OrderList />} />
        <Route path="detail" element={<OrderDetail />} />
        <Route path="back" element={<OrderBack />} />
      </Route>
      <Route path="help" element={<Help />} />
      <Route path="question" element={<Question />} />
      <Route path="feedback" element={<Feedback />} />
      <Route path="settings" element={<Settings />} />
      <Route path="download" element={<Download />} />
      <Route path="agreement" element={<Outlet />}>
        <Route path="delete" element={<AgreementDelete />} />
        <Route
          path="face"
          element={user.from === 'CMCC' ? <AgreementFace2 /> : <AgreementFace />}
        />
        <Route path="privacy" element={<AgreementPrivacy />} />
        <Route path="register" element={<AgreementRegister />} />
        <Route path="userinfo" element={<AgreementUserinfo />} />
        <Route path="userExperience" element={<AgreementUserExperience />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes
